import { WorkflowSection } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

// 計画断面タブは「すべて + 4 区分」(単日 / 週間 / 月間 / 年間)。 タブと保存フィルタの復元
// (persistedFilters) が同じ一覧を見る。 当日・翌日・翌々日は単日に統合された
// (`canonicalWorkflowSection`)。
export const CASE_SECTION_TABS: readonly WorkflowSection[] = [
  WorkflowSection.SINGLE_DAY,
  WorkflowSection.WEEKLY,
  WorkflowSection.MONTHLY,
  WorkflowSection.ANNUAL,
]
